<template>
  <componentCreateExam previewExamName="CommonExam-PaperDetail" backRouteName="CompetitionCenter-PracticeAndExams" />
</template>
<script>
import componentCreateExam from '@/components/PracticeAndExam/createExam.vue'
export default {
  name: 'CommonExam-CreateExam',
  components: {
    componentCreateExam
  }
}
</script>